import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/curatorial", label: "Curatorial Work" },
  { to: "/gallery", label: "Artwork" },
  { to: "/about", label: "About Seyoun" },
  { to: "/contact", label: "Contact" },
];

export function SiteNav() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-canvas/85 backdrop-blur-md border-b border-neutral-200">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-[60] focus:bg-royal focus:text-white focus:px-4 focus:py-2 focus:text-sm"
      >
        Skip to content
      </a>
      <div className="mx-auto max-w-7xl px-6 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-baseline gap-2" onClick={() => setOpen(false)}>
          <span className="font-serif text-xl md:text-2xl tracking-tight text-ink">The House of Ego</span>
        </Link>

        <nav aria-label="Primary" className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `link-underline text-sm tracking-wide ${
                  isActive ? "text-royal font-medium" : "text-neutral-600 hover:text-ink"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/contact"
            data-testid="nav-inquire-button"
            className="ml-2 bg-royal text-white text-sm px-5 py-2.5 hover:bg-royal-deep transition-colors"
          >
            Inquire
          </Link>
        </nav>

        <button
          type="button"
          data-testid="nav-mobile-menu-button"
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          className="lg:hidden p-2 text-ink"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <nav
          aria-label="Mobile"
          data-testid="nav-mobile-menu"
          className="lg:hidden border-t border-neutral-200 bg-white"
        >
          <div className="px-6 py-4 flex flex-col">
            {LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `py-3 text-base border-b border-neutral-100 ${
                    isActive || (l.to === "/gallery" && location.pathname.startsWith("/gallery"))
                      ? "text-royal font-medium"
                      : "text-neutral-700"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              data-testid="nav-mobile-inquire-button"
              onClick={() => setOpen(false)}
              className="mt-4 mb-2 bg-royal text-white text-center text-sm px-5 py-3"
            >
              Inquire
            </Link>
          </div>
        </nav>
      )}
    </header>
  );
}
